export var EDUCATIONAL_INVESTMENT_CODES_OBJECT = {
    HIGH_SCHOOL_ONLY: 'high_school_only',
    TRADE_TECHNICAL_SCHOOL: 'trade_technical_school',
    COMMUNITY_COLLEGE: 'community_college',
    LESS_SELECTIVE_4_YEAR: 'less_selective_4_year',
    SELECTIVE_4_YEAR: 'selective_4_year',
    VERY_SELECTIVE_4_YEAR: 'very_selective_4_year',
    GRADUATE_PROFESSIONAL_SCHOOL: 'graduate_professional_school',
    ENTREPRENEURSHIP: 'entrepreneurship',
    EARLY_CAREER_APPRENTICESHIP: 'early_career_apprenticeship',
    STRONG_MAJOR_FOCUS: 'strong_major_focus',
};
export var EDUCATIONAL_INVESTMENT_CODES = Object.values(EDUCATIONAL_INVESTMENT_CODES_OBJECT);
